/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Terms_Of_ServiceInputs */

const en_common_terms_of_service = /** @type {(inputs: Common_Terms_Of_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Service`)
};

const es_common_terms_of_service = /** @type {(inputs: Common_Terms_Of_ServiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Términos de servicio`)
};

/**
* | output |
* | --- |
* | "Terms of Service" |
*
* @param {Common_Terms_Of_ServiceInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_terms_of_service = /** @type {((inputs?: Common_Terms_Of_ServiceInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Terms_Of_ServiceInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_terms_of_service(inputs)
	return en_common_terms_of_service(inputs)
});